<template>
  <v-dialog width="500px" :value="value" @input="toggleModal" persistent scrollable>
    <v-card class="kbLight">
      <v-toolbar :color="hex" dark text>
        <div class="text-h6">{{$t('general.pickAMainColor')}}</div>
        <v-spacer></v-spacer>
        <v-btn icon @click="toggleModal(false)">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row class="px-12 pt-10 pb-4"   >
          <v-col cols="12">
            <v-slider
              v-model="red"
              color="red"
              thumb-label="always"
              always-dirty
              max="255">
            </v-slider>
          </v-col>
          <v-col cols="12">
            <v-slider
              v-model="green"
              color="green"
              thumb-label="always"
              always-dirty
              max="255">
            </v-slider>
          </v-col>
          <v-col cols="12">
            <v-slider
              v-model="blue"
              color="blue"
              thumb-label="always"
              always-dirty
              max="255"
              hide-details>
            </v-slider>
          </v-col>

          <v-col></v-col>

          <v-col cols="12" class="header centered text-center text-h6 pa-4" :style="{color: hex}" >
            <v-text-field v-model="hex" class="text-center" solo flat :background-color="hex" dark>
            </v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="mr-2" color="red" outlined @click="cancel">{{$t('general.cancel')}}</v-btn>
        <v-btn color="kbBlue" dark @click="submit" :loading="updatingColor">{{$t('general.select')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import colors from '@/libs/colors'
import notifications from '@/libs/notifications'
export default {
  created () {
    this.hex = this.color
  },
  computed: {
    hex: {
      set (value) {
        const rgb = colors.hexToRgb(value)
        if (!rgb) return
        this.red = rgb.r
        this.green = rgb.g
        this.blue = rgb.b
      },
      get () {
        return colors.rgbToHex(this.red, this.green, this.blue)
      }
    }
  },
  data () {
    return {
      updatingColor: false,
      red: 0,
      green: 0,
      blue: 0
    }
  },
  methods: {
    submit () {
      if (this.action === 'updateFormColor') {
        this.updateColor(this.hex)
        this.toggleModal(false)
      } else {
        this.updatingColor = true
        const companyId = this.$store.getters.companyUuid
        const appId = this.$store.getters.appUuid
        const data = { color: this.hex }
        this.$store.dispatch('updateApp', { companyId, appId, data }).then(response => {
          if (response) {
            this.updatingColor = false
            this.toggleModal(false)
            this.$store.dispatch('getApp', { appId, getStatistics: false })
            notifications.success(this.$t('general.successfullyColorUpdated'))
          }
        })
      }
    },
    cancel () {
      this.$emit('input', false)
    },
    toggleModal (value) {
      this.$emit('input', value)
    },
    updateColor (color) {
      this.$emit('updateColor', color)
    }
  },
  props: ['action', 'color', 'value'],
  watch: {
    color () {
      this.hex = this.color
    }
  }
}
</script>

<style>
  .centered .v-input__control .v-input__slot {
    border-radius: 30px !important;
  }

  .centered .v-input__control .v-input__slot .v-text-field__slot input {
    text-align: center !important;
  }
</style>
